import { create } from 'zustand';
import type { AdminProfile, AdminRole, AuthStatus, ModulePermission } from './types';

interface AuthState {
  status: AuthStatus;
  profile: AdminProfile | null;
  role: AdminRole | null;
  permissions: ModulePermission[];
  /** Temp-password login: the user must set a new password before continuing. */
  mustChangePassword: boolean;
  setStatus: (status: AuthStatus) => void;
  setSession: (session: {
    profile: AdminProfile;
    permissions: ModulePermission[];
    mustChangePassword?: boolean;
  }) => void;
  expireSession: () => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'idle',
  profile: null,
  role: null,
  permissions: [],
  mustChangePassword: false,
  setStatus: (status) => set({ status }),
  setSession: ({ profile, permissions, mustChangePassword = false }) =>
    set({ status: 'authenticated', profile, role: profile.role, permissions, mustChangePassword }),
  expireSession: () =>
    set({ status: 'sessionExpired', profile: null, role: null, permissions: [], mustChangePassword: false }),
  clear: () =>
    set({ status: 'unauthenticated', profile: null, role: null, permissions: [], mustChangePassword: false }),
}));
